/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrganizationAdminsResendResponseItem,
    OrganizationAdminsResendResponseItemFromJSON,
    OrganizationAdminsResendResponseItemFromJSONTyped,
    OrganizationAdminsResendResponseItemToJSON,
} from './OrganizationAdminsResendResponseItem';

/**
 * 
 * @export
 * @interface OrganizationAdminsResendResponse
 */
export interface OrganizationAdminsResendResponse {
    /**
     * 
     * @type {Array<OrganizationAdminsResendResponseItem>}
     * @memberof OrganizationAdminsResendResponse
     */
    results?: Array<OrganizationAdminsResendResponseItem>;
}

export function OrganizationAdminsResendResponseFromJSON(json: any): OrganizationAdminsResendResponse {
    return OrganizationAdminsResendResponseFromJSONTyped(json, false);
}

export function OrganizationAdminsResendResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAdminsResendResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(OrganizationAdminsResendResponseItemFromJSON)),
    };
}

export function OrganizationAdminsResendResponseToJSON(value?: OrganizationAdminsResendResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(OrganizationAdminsResendResponseItemToJSON)),
    };
}

